export default "__VITE_ASSET__C2l4I1Hs__"